module.exports = __webpack_public_path__ + "img/login_img.a89060ce.svg";